import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {

  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  iconWrapper: {
    backgroundColor: theme.palette.primary.primary100,
    borderRadius: "6px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "28px",
    height: "28px",
    marginRight: "5px",
    "& svg": {
      verticalAlign: 'middle'
    }
  },
  title: {
    color: theme.palette.black.dark,
    fontSize: '22px',
    fontWeight: 600,
  },
  icon: {
    marginRight: '5px'
  },
  filterBlock: {
    height: 'auto',
    width: '100%',
    borderRadius: '4px',
  },
  searchBy: {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.grey.grey500,
    marginTop: '21px',
    marginBottom: '15px'
  },
  searchForm: {
    display: 'flex'
  },
  searchButton: {
    marginLeft: 'auto',
    '& span': {
      marginLeft: '5px'
    }
  },
  searchInput: {
    '& .MuiInputBase-root': {
      backgroundColor: 'white',
    }
  }
}));

export default useStyles;
